import React from "react";
import { Award, Radio, Newspaper, Building2 } from "lucide-react";

const items = [
  {
    icon: Award,
    label: "Premiato",
    name: "La Stella di E.S.S.E. 2026",
    sub: "Palazzo Valentini · Roma",
    href: null,
  },
  {
    icon: Newspaper,
    label: "Recensito",
    name: "VR Sicilia",
    sub: "Edizione 2026",
    href: "https://www.vrsicilia.it/michele-roccaro-premiato-con-la-stella-di-e-s-s-e-2026-riconosciuto-il-suo-impegno-nellinnovazione-e-nella-formazione/",
  },
  {
    icon: Radio,
    label: "Recensito",
    name: "Radio RTM",
    sub: "Cultura e Innovazione",
    href: "https://www.radiortm.it/2026/05/30/metodo-di-mare-la-rotta-per-navigare-il-cambiamento-tra-crescita-personale-e-professione-digitale/",
  },
  {
    icon: Building2,
    label: "Riconosciuto",
    name: "A.C.D.T. · Legge 4/2013",
    sub: "Aggregato MIMIT",
    href: null,
  },
];

export default function PressStrip() {
  return (
    <section
      data-testid="press-strip"
      className="border-t border-b border-[#E5E1DA] bg-[#F9F8F6] py-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <p className="overline text-center mb-8">Visto su · Riconoscimenti</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-[#E5E1DA] border border-[#E5E1DA]">
          {items.map((it) => {
            const Icon = it.icon;
            const Tag = it.href ? "a" : "div";
            const tagProps = it.href
              ? {
                  href: it.href,
                  target: "_blank",
                  rel: "noopener noreferrer",
                }
              : {};
            return (
              <Tag
                key={it.name}
                {...tagProps}
                data-testid={`press-${it.name}`}
                className="bg-[#F9F8F6] p-6 md:p-7 flex items-center gap-4 group hover:bg-[#FFFFFF] transition-colors"
              >
                <span className="w-11 h-11 border border-[#0B192C]/15 flex items-center justify-center flex-shrink-0 group-hover:border-[#E89B6C] transition-colors">
                  <Icon size={18} strokeWidth={1.3} className="text-[#E89B6C]" />
                </span>
                <div className="min-w-0">
                  <p className="overline text-[#3A4F6B]">{it.label}</p>
                  <p className="font-serif-display text-base md:text-lg leading-tight text-[#0B192C] mt-1 truncate">
                    {it.name}
                  </p>
                  <p className="text-[10px] uppercase tracking-[0.15em] text-[#3A4F6B]/70 mt-0.5">
                    {it.sub}
                  </p>
                </div>
              </Tag>
            );
          })}
        </div>
      </div>
    </section>
  );
}
